'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.From = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = fromKey;

var _utils = require('./utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function compose(f, g) {
  return function (x) {
    return g(f(x));
  };
}

var From = exports.From = function () {
  function From(fromKey) {
    var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (v) {
      return v;
    };

    _classCallCheck(this, From);

    this.isFromKey = true;
    this.fromKey = fromKey;
    this.transform = transform;
  }

  _createClass(From, [{
    key: 'defaultTo',
    value: function defaultTo(defaultValue) {
      return new From(this.fromKey, compose(this.transform, utils.defaultTo(defaultValue)));
    }
  }, {
    key: 'toString',
    value: function toString() {
      return new From(this.fromKey, compose(this.transform, utils.toString));
    }
  }, {
    key: 'toNumber',
    value: function toNumber() {
      return new From(this.fromKey, compose(this.transform, utils.toNumber));
    }
  }, {
    key: 'toInteger',
    value: function toInteger() {
      return new From(this.fromKey, compose(this.transform, utils.toInteger));
    }
  }, {
    key: 'toFloat',
    value: function toFloat() {
      return new From(this.fromKey, compose(this.transform, utils.toFloat));
    }
  }, {
    key: 'toBoolean',
    value: function toBoolean() {
      return new From(this.fromKey, compose(this.transform, utils.toBoolean));
    }
  }, {
    key: 'mapFrom',
    value: function mapFrom(mapping) {
      return new From(this.fromKey, compose(this.transform, utils.mapFrom(mapping)));
    }
  }, {
    key: 'using',
    value: function using(fn) {
      return new From(this.fromKey, compose(this.transform, utils.using(fn)));
    }
  }]);

  return From;
}();

function fromKey(fromKey) {
  return new From(fromKey);
}